// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"761":"e9b09006","2197":"f58b11da","6576":"286cec16","7637":"e4dcedf8","9363":"9b6d4f13"}[chunkId] + ".chunk.css";
};